// extracted by mini-css-extract-plugin
export default {"box":"FileList_box__umO-2","grid":"FileList_grid__cVCXv","fileItem":"FileList_fileItem__xwSTo","fileOffset":"FileList_fileOffset__SyBAO","fileName":"FileList_fileName__dXTxC"};